export default function () {
  this._array = null;
  return Promise.resolve();
}